import React from 'react';
import PropTypes from 'prop-types';
import { Progress } from 'antd';
import { ProgressText, AlertScoreWrapper } from './styled';
import { getAlertColorCode } from '../../utils';

/**
 * ProgressBar
 * @param value {node}
 * @returns {JSX.Element}
 */
const ProgressBar = ({ value = 0, level = 'High' }) => (
  <>
    <ProgressText>{level}</ProgressText>
    <AlertScoreWrapper>
      <ProgressText>{value}</ProgressText>
      <Progress
        percent={value}
        showInfo={false}
        size="small"
        strokeColor={getAlertColorCode(level)}
      />
    </AlertScoreWrapper>
  </>
);

ProgressBar.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  level: PropTypes.string
};

export default ProgressBar;
